import script from "./Path.vue?vue&type=script&setup=true&lang=js"
export * from "./Path.vue?vue&type=script&setup=true&lang=js"

import "./Path.vue?vue&type=style&index=0&id=23a68027&scoped=true&lang=css"

import exportComponent from "C:\\EventPass_actual\\v2\\eventpass-boleteria-v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23a68027"]])

export default __exports__